import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { LocaldataService } from '../../service/localdata/localdata.service';
import { PotatoseedorderPage } from './potatoseedorder/potatoseedorder';

@Component({
  selector: 'app-forms',
  templateUrl: './forms.page.html',
  styleUrls: ['./forms.page.scss'],
})
export class FormsPage implements OnInit {


  constructor(private localData: LocaldataService, private router: Router, private modalCtrl: ModalController, private alertCtrl: AlertController) { }

  ngOnInit() {
  }

  ionViewWillEnter(){
    this.localData.remoteUpdateFormsAvailable();
  }
  
  ionViewDidEnter() {
    this.localData.checkVersionUpdate();
  }

  backToHomepage() {
    this.router.navigate(['/asb/home']);
  }


  async orderPotatoSeed(){
    //this.navCtrl.push(FormsPotatoseedPage);

    let potatoseedorderform = this.localData.availableForms.filter((x, i) => x.systemname==='Potatoseeds'); //NEEDS TO BE CHANGED BACK
    let formobject = potatoseedorderform[0];

    console.log('FORM:', potatoseedorderform);





      /*if(formobject.status=='completed'){
        let alert = this.alertCtrl.create({
          hea: 'Allerede indsendt',
          subTitle: formobject.msgAlreadySubmitted,
          buttons: ['OK']
        });
        alert.present();

      }else if(formobject.status=='deadline exceeded'){
        let alert = this.alertCtrl.create({
          title: 'Deadline overskrevet',
          subTitle: formobject.msgDateOutOfRange,
          buttons: ['OK']
        });
        alert.present();

      }else{*/
      this.gotoForm(formobject)
        //let formModal = this.modalCtrl.create(formobject.component, {'formobject': formobject});
        //formModal.present();
      //}





    //let profileModal = this.modalCtrl.create(FormsPotatoseedPage, { });
    //profileModal.present();


  }

  async gotoForm(formobject){
    console.log('GOTO##', formobject.status, formobject);


    if(formobject.status=='completed'){

      let alert = await this.alertCtrl.create({
        header: 'Allerede indsendt',
        message: formobject.msgAlreadySubmitted,
        buttons: ['OK'],
      });
      await alert.present();

    }else if(formobject.status=='deadline exceeded'){

      let alert = await this.alertCtrl.create({
        header: 'Deadline overskrevet',
        message: formobject.msgDateOutOfRange,
        buttons: ['OK'],
      });
      await alert.present();

    }else if(formobject.isSoldOut){

      let alert = await this.alertCtrl.create({
        header: 'Udsolgt',
        message: formobject.soldOutMsg,
        buttons: ['OK'],
      });
      await alert.present();

    }else{

      let components = {
        'PotatoseedorderPage': PotatoseedorderPage
      }
      

     
      let profileModal = await this.modalCtrl.create(
        {
          component:   components[formobject.component],
          componentProps: {
            formobject: formobject,
            modalCtrl: this.modalCtrl
          },
        });
        profileModal.present();
      
    }
  }

  gotoForms(publisher){
    let navigationExtras: NavigationExtras = {
      queryParams: {
        publisher: publisher
      }
    };
    
    console.log(publisher)
    
    //this.navCtrl.push(FormsAvailablePage, {'publisher': publisher});
  
    this.router.navigate(['/forms-available', {'publisher': publisher}]) ;
  }

}

